import { Box, Button, Typography } from "@mui/material";

const ButtonSys = ({ onClick, text, ...prop }) => {
  return (
    <Box display={"flex"} flexDirection={"row"} justifyContent={"end"}>
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          backgroundColor: (theme) => theme.palette.background.globalButton,
          color: "white",
          textTransform: "uppercase",
          borderRadius: 50,
          wordSpacing: 3,
          padding: { md: "5px 12px", lg: "7px 18px", xl: "10px 24px" },
          minWidth: "auto",
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.background.globalButtonHover,
          },
          "&:active": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
        {...prop}
      >
        <Typography
          variant={"h4"}
          fontWeight={500}
          letterSpacing={3}
          color={(theme) => theme.palette.text.third}
        >
          {text}
        </Typography>
      </Button>
    </Box>
  );
};

export default ButtonSys;
